import { useMemo } from 'react';

import { useParsedQueryParams } from 'hb-react/shared/hooks/useParsedQueryParams';
import { paramTypesForPageLocale } from 'hb-react/shared/hooks/useParsedQueryParams/utils/paramTypesForPageLocale';

export const useQueryParamsForPageLocale = ({
  defaultLocale = I18n.locale || 'en',
}: {
  defaultLocale?: string;
}) => {
  const pageLocaleParamTypes = useMemo(
    () =>
      paramTypesForPageLocale({
        defaultLocale,
      }),
    [defaultLocale],
  );

  const {
    parsedParams: { pageLocale },
    updaters: { updatePageLocale },
  } = useParsedQueryParams({
    paramTypes: pageLocaleParamTypes,
  });

  return {
    pageLocale,
    updatePageLocale,
  };
};
